import React, { useContext, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";

//Styles
import "./NavbarPropDevsSection.css";

//Context
import { LanguageContext } from "../../context/LanguageContext";

const NavbarPropDevsSection = () => {
  const location = useLocation();

  const { t } = useTranslation();

  const [viewMenu, setViewMenu] = useState(false);

  const { traslate, toggleLanguage } = useContext(LanguageContext);

  return (
    <nav className="nb-prop-devs-container">
      <div className="nb-prop-devs-logo-supercontainer">
        <Link to="/" className="nb-prop-devs-logo-container">
          <img
            src={
              location.pathname === "/vivienda"
                ? "https://pagina-otacc.s3.amazonaws.com/pages/otacc-page/assets/icons/logo-otacc.webp"
                : "https://pagina-otacc.s3.amazonaws.com/pages/otacc-page/assets/icons/logo-otacc-white.webp"
            }
            alt="logo de Otacc"
            className="nb-prop-devs-logo-img"
          />
        </Link>
        {/* {location.pathname === "/renovables" && (
          <Link to="/" className="nb-prop-devs-logo-container">
            <img
              src="https://pagina-otacc.s3.us-east-1.amazonaws.com/pages/otacc-page/assets/icons/logo-otacc-alt.webp"
              alt="logo alternativo de Otacc"
              className="nb-prop-devs-logo-img"
              style={{ transform: "scale(1.25)" }}
            />
          </Link>
        )} */}
      </div>
      <div className="nb-prop-devs-menus-supercontainer">
        <div className="nb-prop-devs-menus-container-nm">
          <Link
            to="/vivienda"
            className={`nb-prop-devs-option ${
              location.pathname === "/vivienda" ? "current" : ""
            } ${location.pathname === "/vivienda" ? "text-darken" : ""}`}
          >
            {t("navbar.title_1")}
          </Link>
          <Link
            to="/oil-and-gas"
            className={`nb-prop-devs-option ${
              location.pathname === "/oil-and-gas" ? "current" : ""
            } ${location.pathname === "/vivienda" ? "text-darken" : ""}`}
          >
            {t("navbar.title_2")}
          </Link>
          <Link
            to="/renovables"
            className={`nb-prop-devs-option ${
              location.pathname === "/renovables" ? "current" : ""
            } ${location.pathname === "/vivienda" ? "text-darken" : ""}`}
          >
            {t("navbar.title_3")}
          </Link>
          <Link
            to="/infraestructura"
            className={`nb-prop-devs-option ${
              location.pathname === "/infraestructura" ? "current" : ""
            } ${location.pathname === "/vivienda" ? "text-darken" : ""}`}
          >
            {t("navbar.title_4")}
          </Link>
          <Link
            to="/nosotros"
            className={`nb-prop-devs-option ${
              location.pathname === "/nosotros" ? "current" : ""
            } ${location.pathname === "/vivienda" ? "text-darken" : ""}`}
          >
            {t("navbar.title_5")}
          </Link>
        </div>
        <div className="nb-prop-devs-mobile-container">
          <img
            onClick={() => setViewMenu(!viewMenu)}
            src="https://pagina-otacc.s3.amazonaws.com/pages/otacc-page/assets/ham-menu-icon.webp"
            alt=""
            className="ham-icon"
          />
          <div
            className={`mb-prop-devs-menus-container ${
              viewMenu ? "" : "closed-menu"
            }`}
          >
            <Link
              to="/vivienda"
              className="nb-prop-devs-option"
              onClick={() => setViewMenu(false)}
            >
              {t("navbar.title_1")}
            </Link>
            <Link
              to="/oil-and-gas"
              className="nb-prop-devs-option"
              onClick={() => setViewMenu(false)}
            >
              {t("navbar.title_2")}
            </Link>
            <Link
              to="/renovables"
              className="nb-prop-devs-option"
              onClick={() => setViewMenu(false)}
            >
              {t("navbar.title_3")}
            </Link>
            <Link
              to="/infraestructura"
              className="nb-prop-devs-option"
              onClick={() => setViewMenu(false)}
            >
              {t("navbar.title_4")}
            </Link>
            <Link
              to="/nosotros"
              className="nb-prop-devs-option"
              onClick={() => setViewMenu(false)}
            >
              {t("navbar.title_5")}
            </Link>
          </div>
        </div>
        <div>
          <button className="nb-language-btn" onClick={toggleLanguage}>
            <img
              src={`https://flagcdn.com/w40/${!traslate ? "co" : "us"}.png`}
              alt={!traslate ? "Colombia" : "USA"}
              width="20"
              style={{ verticalAlign: "middle", marginRight: 8 }}
            />
            {!traslate ? "ES" : "EN"}
          </button>
        </div>
      </div>
    </nav>
  );
};

export default NavbarPropDevsSection;
